import { Link } from 'react-router-dom'

import { T } from '@tribeplatform/react-components/i18n'
import { SpaceImage } from '@tribeplatform/react-components/Space'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { SpacePrivacyIcon } from '../Space/SpacePrivacyIcon'

export const SpaceCard = ({ space, fields = [] }) => {
  if (!fields.length) {
    fields = ['image', 'name', 'membersCount', 'postsCount']
  }
  if (!space) {
    return null
  }

  return (
    <Card className="h-full">
      <Link to={space.relativeUrl}>
        <div className="flex-1 flex flex-col mb-2 p-6 pt-4 items-center text-center">
          {fields.map(field => {
            switch (field) {
              case 'image':
                return (
                  <div key={field} className="mb-3">
                    <SpaceImage space={space} size="lg" />
                  </div>
                )
              case 'name':
                return (
                  <div
                    key={field}
                    className="flex space-s-1 items-center mb-2 max-w-full"
                  >
                    <h4 className="text-content max-w-full line-clamp-2 ">
                      {space.name}
                    </h4>
                    <SpacePrivacyIcon space={space} size="sm" />
                  </div>
                )
              case 'membersCount':
                return (
                  <div
                    key={field}
                    className="text-content-subdued text-sm max-w-full truncate"
                  >
                    <T
                      defaultMessage="{members_count, plural, =0 {No {MEMBERS}} =1 {# {MEMBER}} other {# {MEMBERS}}}"
                      id="Space.MembersCount"
                      values={{
                        members_count: space.membersCount || 0,
                      }}
                    />
                  </div>
                )
              case 'postsCount':
                return (
                  <div
                    key={field}
                    className="text-content-subdued text-sm max-w-full truncate"
                  >
                    <T
                      defaultMessage="{posts_count, plural, =0 {No posts} =1 {# post} other {# posts}}"
                      id="Generics.Posts.Plural"
                      values={{
                        posts_count: space.postsCount || 0,
                      }}
                    />
                  </div>
                )
              default:
                return null
            }
          })}
        </div>
      </Link>
    </Card>
  )
}
